/* Read-only PDP adapter: custom, classic and hot-reloaded flex product pages. */
(function () {
  'use strict';
  var api = window.__ga4Journey, pdp = window.__pdp, config = window.__ga4JourneyConfig || {};
  if (!api) return;
  var isProduct = config.pageType === 'product' && pdp && pdp.product;
  var viewed = false, variant = null, quantity = 1, media = new Map(), suspended = false;
  var scrollMax = 0, foregroundStart = null, foregroundMs = 0, scrollSent = false;
  var template = pdp && pdp.template || 'unknown';
  var contextFingerprint = null, contextId = null;
  var zoomRoots = new WeakSet();
  var mediaSeen = new Set(), lastMediaId = null, mediaIntent = null, pointer = null;
  var externalFrames = new WeakSet(), providerRequested = {}, providerTimer = null, providerDeadline = 0;
  function externalState(frame, state) {
    if (api.isAllowed() && frame && frame.isConnected) document.dispatchEvent(new CustomEvent('ga4:media-state', { detail: { frame: frame, state: state } }));
  }
  function bindExternalFrames() {
    if (!api.isAllowed()) return;
    var waiting = false;
    // 自定义 PDP 原有静态 iframe 没有播放器实例；只接官方回调，不调用播放/暂停或重写 src。
    document.querySelectorAll('.product-main [data-pm-slide-id] iframe').forEach(function (frame) {
      if (externalFrames.has(frame)) return;
      var url;
      try { url = new URL(frame.src); } catch (_) { return; }
      var host = url.hostname, youtube = /^(www\.)?youtube(-nocookie)?\.com$/.test(host), vimeo = host === 'player.vimeo.com';
      if (!youtube && !vimeo) return;
      try {
        if (youtube && window.YT && window.YT.Player) {
          externalFrames.add(frame);
          new window.YT.Player(frame, { events: { onStateChange: function (event) {
            var state = { 1: 'play', 2: 'pause', 0: 'ended', 3: 'buffering' }[event.data];
            if (state) externalState(frame, state);
          } } });
        } else if (vimeo && window.Vimeo && window.Vimeo.Player) {
          externalFrames.add(frame);
          var player = new window.Vimeo.Player(frame);
          var revision = 0;
          ['play', 'pause', 'ended', 'bufferstart', 'bufferend'].forEach(function (name) {
            player.on(name, function () {
              if (!api.isAllowed()) return;
              var current = ++revision, pageId = api.pageId();
              if (name === 'bufferend') player.getPaused().then(function (paused) { if (!paused && current === revision && api.pageId() === pageId) externalState(frame, 'play'); }).catch(function () {});
              else externalState(frame, name === 'bufferstart' ? 'buffering' : name);
            });
          });
        } else {
          var provider = youtube ? 'youtubeSdk' : 'vimeo';
          if (!providerRequested[provider]) {
            providerRequested[provider] = true;
            providerDeadline = Date.now() + 10000;
            if (window.theme && theme.LibraryLoader) theme.LibraryLoader.load(provider, youtube ? undefined : window.vimeoApiReady);
            else api.noteSkipped('pdp_media_engagement', 'provider_loader_unavailable');
          }
          waiting = true;
        }
      } catch (_) { externalFrames.add(frame); api.noteSkipped('pdp_media_engagement', 'provider_binding_failed'); }
    });
    if (waiting && !providerTimer && Date.now() < providerDeadline) providerTimer = setTimeout(function () { providerTimer = null; bindExternalFrames(); }, 250);
  }
  ['media:play', 'media:pause'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      var element = event.target;
      if (element.matches && element.matches('video-media[host]')) externalState(element.querySelector('iframe'), name === 'media:play' ? 'play' : 'pause');
    });
  });
  ['youTubeReady', 'vimeoReady'].forEach(function (name) { document.addEventListener(name, bindExternalFrames); });
  function pageRoot() {
    if (!isProduct) return null;
    return document.querySelector('product-hot-reload, .product-main, [data-section-type="product"]') || document.querySelector('main');
  }
  function selected() {
    var root = pageRoot(), live = root && root.querySelector('[data-ga4-product-state]');
    if (live) {
      try {
        var state = JSON.parse(live.textContent);
        if (String(state.product_id) === String(pdp.product.id) && state.variant) {
          return Object.assign({}, (pdp.variants || []).find(function (v) { return String(v.id) === String(state.variant.id); }), state.variant);
        }
      } catch (_) {}
    }
    var input = root && root.querySelector('[data-pm-variant-id], select[name="id"], input[name="id"]');
    return (pdp.variants || []).find(function (v) { return input && String(v.id) === input.value; }) || variant || pdp.variant;
  }
  function currentQuantity() {
    var root = pageRoot(), input = root && root.querySelector('[data-pm-qty], [name="quantity"]');
    var value = Number(input ? input.value : 1);
    return Number.isInteger(value) && value > 0 ? value : quantity;
  }
  function commerce(v) {
    if (!v || !v.id || v.price == null || !isFinite(Number(v.price)) || !config.currency) return null;
    var item = { item_id: String(pdp.product.id),
      item_name: pdp.product.title, item_variant: String(v.id), product_handle: pdp.product.handle,
      price: Number(v.price) / 100, quantity: 1 };
    if (pdp.product.vendor) item.item_brand = pdp.product.vendor;
    if (pdp.product.type) item.item_category = pdp.product.type;
    if (typeof v.compare_at_price === 'number' && isFinite(v.compare_at_price) && v.compare_at_price >= 0) {
      item.compare_at_price = v.compare_at_price / 100;
      item.discount = Math.max(0, v.compare_at_price - Number(v.price)) / 100;
    }
    return { currency: config.currency, pdp_template: template, items: [item] };
  }
  function contentText(el) { return el ? el.textContent.replace(/\s+/g, ' ').trim() : ''; }
  function productFacts(commercePayload) {
    var item = commercePayload.items[0];
    var result = { currency: commercePayload.currency, pdp_template: template, product_id: item.item_id, variant_id: item.item_variant, price: item.price };
    if (item.compare_at_price !== undefined) result.compare_at_price = item.compare_at_price;
    if (item.discount !== undefined) result.discount = item.discount;
    return result;
  }
  function contextDetail(type, index, count, title, description, descriptionLimit) {
    // 保留旧字典的 80/120/160 字边界；两个文本字段可直接拼接，不上传序列化对象。
    var heading = Array.from(title), body = Array.from(description);
    return { detail_type: type, detail_index: index, detail_count: count,
      content_name: heading.slice(0, 80).join(''), content_description: body.slice(0, 100).join(''),
      content_description_continued: body.slice(100, descriptionLimit).join(''),
      text_truncated: heading.length > 80 || body.length > descriptionLimit };
  }
  function syncContext(next, commercePayload) {
    var root = pageRoot();
    if (!root) return;
    var badges = Array.from(root.querySelectorAll('.pm-badge, .element-badge')).filter(function (el) { return displayedMedia(el) && contentText(el); });
    var benefits = Array.from(root.querySelectorAll('.pm-benefit')).filter(function (el) {
      return displayedMedia(el) && (contentText(el.querySelector('.pm-benefit-title')) || contentText(el.querySelector('.pm-benefit-sub')));
    });
    var item = commercePayload.items[0];
    // 实站 gtag 不为该自定义事件编码 items；商品元数据必须有明确标量明细。
    var productDetail = Object.assign(contextDetail('product', 1, 1, '', '', 0), {
      product_id: item.item_id, product_title: item.item_name, product_handle: item.product_handle
    });
    if (item.item_brand) productDetail.product_vendor = item.item_brand;
    if (item.item_category) productDetail.product_type = item.item_category;
    var details = [productDetail].concat(badges.map(function (el, index) { return contextDetail('badge', index + 1, badges.length, contentText(el), '', 0); }));
    benefits.forEach(function (el, index) {
      details.push(contextDetail('benefit', index + 1, benefits.length, contentText(el.querySelector('.pm-benefit-title')), contentText(el.querySelector('.pm-benefit-sub')), 120));
    });
    var review = Array.from(root.querySelectorAll('.jdgm-prev-badge, .shopify-product-reviews-badge, .pm-reviews')).find(displayedMedia);
    var stock = Array.from(root.querySelectorAll('.pm-stock, [data-product-inventory]')).find(displayedMedia);
    if (review && contentText(review)) details.push(contextDetail('review_summary', 1, 1, '', contentText(review), 160));
    if (stock && contentText(stock)) details.push(contextDetail('stock_message', 1, 1, '', contentText(stock), 160));
    var payload = Object.assign(productFacts(commercePayload), { badge_count: badges.length, benefit_count: benefits.length, context_detail_count: details.length,
      stock_status: next.available === true ? 'in_stock' : (next.available === false ? 'out_of_stock' : 'unknown') });
    if (typeof next.inventory_quantity === 'number' && Number.isInteger(next.inventory_quantity)) payload.stock_level = next.inventory_quantity;
    var summary = review && (review.matches('[data-average-rating], [data-number-of-reviews]') ? review : review.querySelector('[data-average-rating], [data-number-of-reviews]'));
    if (summary) {
      var rating = summary.getAttribute('data-average-rating'), count = summary.getAttribute('data-number-of-reviews');
      if (rating && isFinite(Number(rating)) && Number(rating) >= 0 && Number(rating) <= 5) payload.review_rating = Number(rating);
      if (count && Number.isInteger(Number(count)) && Number(count) >= 0) payload.review_count = Number(count);
    }
    var fingerprint = JSON.stringify([payload, details]);
    if (fingerprint === contextFingerprint) return contextId;
    if (details.length > 64) { api.noteSkipped('pdp_product_context', 'context_detail_limit'); return null; }
    payload.product_context_id = api.uuid();
    payload.context_reason = !contextFingerprint ? 'initial' : (variant && String(variant.id) !== String(next.id) ? 'variant_changed' : 'content_changed');
    if (!api.emit('pdp_product_context', payload)) return null;
    contextFingerprint = fingerprint; contextId = payload.product_context_id;
    details.forEach(function (detail) { api.emit('pdp_context_detail', Object.assign({ product_context_id: contextId }, detail)); });
    return contextId;
  }
  function syncProduct(next) {
    if (!isProduct || !api.isAllowed() || document.visibilityState === 'hidden' || suspended) return;
    next = next || selected();
    var payload = commerce(next);
    if (!payload) { api.noteSkipped('view_item', 'missing_product_data'); return; }
    var matchedContext = syncContext(next, payload);
    if (matchedContext) payload.product_context_id = matchedContext;
    if (!viewed) { payload.value = payload.items[0].price; viewed = api.emit('view_item', payload); }
    else if (variant && String(variant.id) !== String(next.id)) {
      var selection = Object.assign(productFacts(payload), { previous_variant_id: String(variant.id) });
      if (matchedContext) selection.product_context_id = matchedContext;
      api.emit('pdp_variant_select', selection);
    }
    variant = next;
  }
  function syncQuantity(method) {
    if (!isProduct || !api.isAllowed()) return;
    var next = currentQuantity();
    if (next !== quantity) api.emit('pdp_quantity_change', { previous_quantity: quantity, quantity: next, change_method: method, pdp_template: template });
    quantity = next;
  }
  document.addEventListener('variant:change', function (event) {
    var next = event.detail && event.detail.variant;
    if (!isProduct || !next || !(pdp.variants || []).some(function (v) { return String(v.id) === String(next.id); })) return;
    syncProduct(next);
  });
  document.addEventListener('change', function (event) {
    var root = pageRoot();
    if (!root || !root.contains(event.target)) return;
    if (event.target.matches('[name="quantity"], [data-pm-qty]')) syncQuantity('input');
    syncProduct();
  });
  document.addEventListener('click', function (event) {
    var root = pageRoot();
    if (!api.isAllowed() || !root || !root.contains(event.target)) return;
    if (event.target.closest('[data-pm-qty-plus], [data-pm-qty-minus], .js-qty__adjust, quantity-selector button')) syncQuantity('stepper');
  });
  var mediaSelector = '[data-pm-slide-id], .product-main-slide, .media-gallery__slide, .media-grid__container';
  document.addEventListener('click', function (event) {
    if (!api.isAllowed() || !event.target.closest || !pageRoot() || !pageRoot().contains(event.target)) return;
    var target = event.target.closest('[data-pm-thumb-id], .product__thumb, .media-gallery__thumb, .media-gallery__nav, .media-gallery__nav--prev, .media-gallery__nav--next, [data-product-images] .flickity-button');
    if (target) mediaIntent = { method: target.matches('[data-pm-thumb-id], .product__thumb, .media-gallery__thumb') ? 'thumbnail_click' : 'arrow_click', at: performance.now(), previous: lastMediaId };
  }, true);
  document.addEventListener('pointerdown', function (event) {
    pointer = api.isAllowed() && event.target.closest && event.target.closest(mediaSelector) && !event.target.closest('video, iframe, button, a') ? { x: event.clientX, y: event.clientY } : null;
  }, true);
  document.addEventListener('pointerup', function (event) {
    if (pointer && api.isAllowed() && Math.abs(event.clientX - pointer.x) >= 30 && Math.abs(event.clientX - pointer.x) > Math.abs(event.clientY - pointer.y)) mediaIntent = { method: 'swipe', at: performance.now(), previous: lastMediaId };
    pointer = null;
  }, true);
  function mediaFields(el) {
    var root = el.closest('[data-pm-track], [data-product-photos], [data-media-gallery], media-gallery, .media-grid') || pageRoot();
    var list = root ? Array.from(root.querySelectorAll(mediaSelector)) : [el];
    return { media_id: el.dataset.pmSlideId || el.dataset.mediaId || String(list.indexOf(el) + 1),
      media_index: list.indexOf(el) + 1, media_count: list.length,
      media_type: el.dataset.pmMediaType || el.dataset.mediaType || (el.querySelector('video') ? 'video' : (el.querySelector('iframe') ? 'external_video' : (el.querySelector('model-viewer') ? 'model' : 'image'))) };
  }
  function endMedia(state, reason) {
    if (state.start !== null) {
      api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: 'media_dwell', view_duration_ms: Math.round(performance.now() - state.start), dwell_end_reason: reason }));
      state.start = null;
    }
    if (state.watch !== null) {
      api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: 'video_watch', watch_duration_ms: Math.round(performance.now() - state.watch), dwell_end_reason: reason }));
      state.watch = null;
    }
  }
  function displayedMedia(el) {
    if (el.matches('.media-gallery__slide') && !el.classList.contains('media-gallery__slide--active')) return false;
    if (el.closest('[hidden], [inert], [aria-hidden="true"]')) return false;
    // flex 用透明叠层保留未选媒体的几何尺寸，IO 相交不等于实际展示。
    var current = el;
    while (current && current !== document.body) {
      var style = getComputedStyle(current);
      if (style.display === 'none' || style.visibility === 'hidden' || style.visibility === 'collapse' || Number(style.opacity) === 0) return false;
      current = current.parentElement;
    }
    return true;
  }
  function startMedia(state, el) {
    if (!api.isAllowed() || suspended || document.visibilityState === 'hidden' || !state.visible || !displayedMedia(el)) return;
    if (state.start === null) {
      if (!state.seen) {
        mediaSeen.add(state.fields.media_id);
        api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: 'media_view', media_seen_count: mediaSeen.size }));
        if (mediaIntent && performance.now() - mediaIntent.at < 2000 && mediaIntent.previous && mediaIntent.previous !== state.fields.media_id) {
          api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: 'media_change', interaction_method: mediaIntent.method, previous_media_id: mediaIntent.previous, media_seen_count: mediaSeen.size }));
          mediaIntent = null;
        }
        lastMediaId = state.fields.media_id;
        state.seen = true;
      }
      state.start = performance.now();
    }
    var video = el.querySelector('video');
    if (((video && !video.paused && !video.ended) || state.externalPlaying) && state.watch === null) state.watch = performance.now();
  }
  function reconcileMedia(state, el, reason) {
    if (state.visible && displayedMedia(el)) startMedia(state, el);
    else { endMedia(state, reason); state.seen = false; }
  }
  var observer = window.IntersectionObserver && new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      var state = media.get(entry.target);
      if (!state) return;
      var rect = entry.boundingClientRect, area = Math.min(rect.width, innerWidth) * Math.min(rect.height, innerHeight);
      state.visible = entry.isIntersecting && area > 0 && entry.intersectionRect.width * entry.intersectionRect.height >= area * 0.5;
      reconcileMedia(state, entry.target, 'viewport_exit');
    });
  }, { threshold: Array.from({ length: 101 }, function (_, i) { return i / 100; }) });
  function scan() {
    if (!isProduct) return;
    syncProduct();
    media.forEach(function (state, el) { if (!el.isConnected) { endMedia(state, 'removed'); observer.unobserve(el); media.delete(el); } });
    var root = pageRoot();
    if (!observer || !root) return;
    root.querySelectorAll('[data-product-images]').forEach(function (gallery) {
      if (zoomRoots.has(gallery)) return;
      zoomRoots.add(gallery);
      // PhotoSwipe 的实际切图回调确认打开，不把未打开的缩放按钮点击当成成功。
      gallery.addEventListener('photoswipe:afterChange', function (event) {
        if (!api.isAllowed() || document.visibilityState === 'hidden') return;
        var images = gallery.querySelectorAll(gallery.dataset.hasSlideshow === 'true' ? '.flickity-viewport .photoswipe__image' : '.photoswipe__image');
        var index = event.detail && event.detail.index, image = Number.isInteger(index) && images[index] && images[index].closest(mediaSelector);
        if (image) api.emit('pdp_media_engagement', Object.assign(mediaFields(image), { action: 'image_zoom', interaction_method: 'photoswipe' }));
      });
    });
    root.querySelectorAll(mediaSelector).forEach(function (el) {
      if (media.has(el)) {
        var state = media.get(el), nextFields = mediaFields(el);
        if (state.fields.media_id !== nextFields.media_id) { endMedia(state, 'metadata_changed'); state.seen = false; state.externalPlaying = false; }
        state.fields = nextFields; reconcileMedia(state, el, 'visibility_changed'); return;
      }
      if (el.closest('[id^="QuickShop"]')) return;
      media.set(el, { fields: mediaFields(el), start: null, watch: null, visible: false, seen: false });
      observer.observe(el);
    });
    bindExternalFrames();
  }
  document.addEventListener('ga4:media-state', function (event) {
    var detail = event.detail || {}, frame = detail.frame;
    if (!api.isAllowed() || !frame || !frame.isConnected || !frame.closest) return;
    var el = frame.closest(mediaSelector), state = el && media.get(el);
    if (!state || ['play', 'pause', 'ended', 'buffering'].indexOf(detail.state) < 0) return;
    var wasPlaying = state.externalPlaying;
    state.externalPlaying = detail.state === 'play';
    if (state.externalPlaying) {
      if (!wasPlaying && state.visible && displayedMedia(el) && document.visibilityState !== 'hidden') api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: 'video_play', interaction_method: 'provider_callback' }));
      startMedia(state, el);
    } else if (state.watch !== null) {
      api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: 'video_' + detail.state, interaction_method: 'provider_callback', watch_duration_ms: Math.round(performance.now() - state.watch) }));
      state.watch = null;
    }
  });
  ['play', 'pause', 'ended'].forEach(function (name) {
    document.addEventListener(name, function (event) {
      if (!api.isAllowed() || !event.target.matches('video')) return;
      var el = event.target.closest(mediaSelector), state = el && media.get(el);
      if (!state) return;
      if (name === 'play') {
        if (!state.visible || !displayedMedia(el) || document.visibilityState === 'hidden') return;
        api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: 'video_play' }));
        startMedia(state, el);
      } else if (state.watch !== null) {
        api.emit('pdp_media_engagement', Object.assign({}, state.fields, { action: name === 'ended' ? 'video_ended' : 'video_pause', watch_duration_ms: Math.round(performance.now() - state.watch) }));
        state.watch = null;
      }
    }, true);
  });
  function sampleScroll() {
    if (!isProduct || !api.isAllowed() || document.visibilityState === 'hidden') return;
    scrollMax = Math.max(scrollMax, Math.min(100, Math.round((scrollY + innerHeight) / Math.max(document.documentElement.scrollHeight, innerHeight) * 100)));
    scrollSent = false;
  }
  function pause(reason) {
    media.forEach(function (state) { endMedia(state, reason); });
    if (foregroundStart !== null) { foregroundMs += performance.now() - foregroundStart; foregroundStart = null; }
    if (isProduct && api.isAllowed() && !scrollSent) {
      api.emit('pdp_scroll_depth', { scroll_max_pct: scrollMax, time_on_page_ms: Math.round(foregroundMs), pdp_template: template });
      scrollSent = true;
    }
  }
  function resume() {
    if (isProduct && api.isAllowed() && document.visibilityState !== 'hidden') {
      if (foregroundStart === null) foregroundStart = performance.now();
      syncProduct(); media.forEach(startMedia); sampleScroll();
    }
  }
  function reset() {
    clearTimeout(providerTimer); providerTimer = null;
    mediaSeen.clear(); lastMediaId = null; mediaIntent = null; pointer = null;
    viewed = false; variant = null; contextFingerprint = null; contextId = null; quantity = currentQuantity(); scrollMax = 0; foregroundMs = 0; foregroundStart = null; scrollSent = false;
    media.forEach(function (state) { state.start = null; state.watch = null; state.seen = false; state.externalPlaying = false; });
    scan(); resume();
  }
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') pause('hidden'); else resume(); });
  window.addEventListener('pagehide', function () { suspended = true; pause('pagehide'); });
  window.addEventListener('pageshow', function () { suspended = false; resume(); });
  window.addEventListener('scroll', sampleScroll, { passive: true });
  api.onConsent(reset); api.onPageView(reset);
  var scheduled = false;
  function scheduleScan() {
    if (scheduled) return;
    scheduled = true; requestAnimationFrame(function () { scheduled = false; scan(); });
  }
  if (isProduct) new MutationObserver(function (records) {
    var root = pageRoot();
    if (records.some(function (record) {
      return record.type === 'childList' || record.type === 'characterData' || (root && root.contains(record.target));
    })) scheduleScan();
  }).observe(document.body, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['data-variant-id', 'data-average-rating', 'data-number-of-reviews', 'class', 'style', 'hidden', 'inert', 'aria-hidden'] });
  document.addEventListener('transitionend', function (event) {
    if (isProduct && (event.target.matches(mediaSelector) || event.target.querySelector(mediaSelector))) scheduleScan();
  }, true);
  window.addEventListener('resize', scheduleScan, { passive: true });
  reset();
  api.registerModule('product', function () { return { applicable: !!isProduct, productViewed: viewed, mediaObserved: media.size, productContextId: contextId }; });
})();
